import { FrameEditUser } from '@Modules/Permissions';
import { RouteObject } from 'react-router';

export function setupProfileRouting(): RouteObject {
    return {
        path: 'profile',
        children: [
            {
                path: 'me',
                element: <FrameEditUser isOwnProfileView />,
            },
        ],
    };
}
